<template>
    <div>
      <div class="row justify-content-center">
                          <div class=" col-sm-12 grid-margin stretch-card">

                            <div class="card">
                              <div class="card-tile text-center p-2">
                                <ul class="nav nav-pills nav-fill">
      <li class="nav-item">
        <a class="nav-link" aria-current="page" href="/numbers">Safaricom Zambaza Lines</a>
      </li>
      <li class="nav-item">
        <a class="nav-link active" href="#">Airtel Receiver Lines</a>
      </li>
    </ul>

                                <div class="mb-3 row justify-content-center mt-5">
                                  <div class="col-sm-6 float-right">
                                  <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">

                                  </div>
                                   <div class="col-sm-4 float-right">
                                    <a class="btn btn-success" v-on:click="showAddModal()">Add Numbers</a>
                                   </div>
                                </div>
                                </div>
                              <div class="card-body text-center">

                                <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>

                        <tr class="text-center">
                          <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                          <th class="text-uppercase  text-xxs font-weight-bolder  ">Number</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Created At</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Updated At</th>
                          <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>

                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data,index) in numbers" :key="data.id" class="text-center" v-bind:class = "(data.status)?'bg-default':'bg-secondary'">
                          <td>
                            {{index+1}}
                          </td>
                          <td>
                            {{data.number}} <a href="#" v-on:click="showModal(data.id,data.number,data.balance,data.status)" class=""><i class="mdi mdi-pencil text-success"></i></a>
                          </td>
                          <td>
                            {{filerDate(data.created_at)}}
                          </td>
                          <td>
                            {{filerDate(data.updated_at)}}
                          </td>
                          <td v-if="data.status">
                            <label class="switch">
      <input type="checkbox" checked v-on:click="updateAirtelNumberStatus(data.id,'0')">
      <span class="slider round"></span>
    </label>
                          </td>
                          <td v-else>
                            <label class="switch">
      <input type="checkbox" v-on:click="updateAirtelNumberStatus(data.id,'1',data.number,data.balance)">
      <span class="slider round"></span>
    </label>
                          </td>

                        </tr>
                      </tbody>
                    </table>
                  </div>

                              </div>
                            </div>




                            </div>
                            </div>

      <div class="modal fade" id="add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-body">
             <h6 class="text-center">Add a Number</h6>
             <div class="form-group">
                        <label class="form-label">Number</label>
                        <input type="text" v-model="message.number" class="form-control" required>
                      </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" v-on:click="addAirtelNumber()">Save Number</button>
          </div>
        </div>
      </div>
    </div>
      <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-body">
             <h6 class="text-center">Update Number</h6>
             <div class="form-group">
                        <label class="form-label">Number</label>
                        <input type="text" v-model="message.number" class="form-control" required>
                      </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-success" v-on:click="updateAirtelNumber()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
    </div>
    </template>
    <script>
        import moment from 'moment'
        export default {
            name: 'App',
            components: {

            },
            data(){
                return {
                numbers:[],
                numbers2:[],
                message:{id:'',number:'',balance:'10000',status:true}

                }
            },
            created(){
                  this.getAirtelNumbers();
            },
            methods: {
              showAddModal(){
                  $('#add').modal('show');
              },
              showModal(id,number,balance,status){
                this.message.number=number;
                this.message.id=id;
                this.message.balance=balance;
                this.status=status;
                 $('#edit').modal('show');
              },
              addAirtelNumber(){
                $('#add').modal('hide');
                 this.$loading(true)
                   let uri =`/api/auth/addAirtelNumber`;
                    this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       this.getAirtelNumbers();
                       }else{
                       this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
              removeNumber(id){
                 this.$loading(true)
                   let uri =`/api/auth/removeNumber/${id}`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       this.getAirtelNumbers();
                       }else{
                       this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
              updateAirtelNumberStatus(id,status,number,balance){
                this.message.id=id;
                this.message.status=status;
                this.message.number=number;
                this.message.balance=balance;
                 this.$loading(true)
                   let uri =`/api/auth/updateAirtelNumber`;
                    this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       this.getAirtelNumbers();
                       }else{
                       this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
              updateAirtelNumber(){
                $('#edit').modal('hide');
                 this.$loading(true)
                   let uri =`/api/auth/updateAirtelNumber`;
                    this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.$loading(false)
                       if(response.data.status){
                       this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                       this.getAirtelNumbers();
                       }else{
                       this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                       }
                    }).catch(error => {
                       this.$loading(false)
                        if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
              },
                getAirtelNumbers(){
                    let uri =`/api/auth/getAirtelNumbers`;
                    this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                        this.numbers2=response.data;
                       this.numbers=response.data;
                    }).catch(error => {

                       if (error.response.status === 401) {
                        this.$router.push({name: 'index'});
                        this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});

                    }else{
                        this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                    }

                    });
                },

                filter(){
                let filterval=this.message.filterval;
                if(filterval==='' || filterval===null){
                    this.numbers=this.numbers2;
                }else{
                    let ads =  this.numbers2.filter(function(product) {
                        return product.number.toLowerCase().includes(filterval.toLowerCase())
                    });
                    this.numbers=ads;
                }
            },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                },
                filerDate(date){
                    return moment(String(date)).format('MM/DD/YYYY HH:mm')
                }

            },
        }

    </script>
